module.exports = "<h1 l10nTranslate>home-welcome</h1>\r\n<p l10nTranslate>home-seedocs</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = 1